import React, { useState } from 'react';
import { Button, Upload, Image, Form, Card, Row, Col, Empty } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { UPLOAD_IMG_URL } from 'utils/config';
import { FormInstance } from 'antd/lib/form';
import { setValueByNamePath, shouldUpdateCompare } from 'utils/utils2';
import { isNil } from 'lodash';
import {
  updateAssetCatalogOptionPicturePath,
  updateAssetCatalogPicturePath,
} from 'services/assetconfig';
import { UploadDocumentFile } from 'utils/request';

type AssetUploadProps = {
  name?: string;
  namePath?: (string | number)[];
  form: FormInstance;
  value?: any;
  catalogid?: number;
  opid?: number;
  picid?: number;
  simpleUpload?: boolean;
  refetch?: () => void;
  objectreference: string;
};

const AssetUpload = ({
  value = null,
  form,
  name,
  namePath,
  catalogid,
  opid,
  picid,
  simpleUpload,
  refetch,
  objectreference,
}: AssetUploadProps) => {
  const [fileList, setFileList] = useState<any[]>(
    value
      ? [
          {
            uid: '-1',
            name: value,
            status: 'done',
            url: UPLOAD_IMG_URL + value,
          },
        ]
      : []
  );
  const handleUploadOrRemove = (
    file: string | null,
    action: 'UPLOAD' | 'REMOVE'
  ) => {
    if (action === 'UPLOAD') {
      const fileName = String(file);
      if (!simpleUpload || isNil(simpleUpload)) {
        if (name) {
          form.setFieldsValue({ [name]: fileName });
          updateAssetCatalogPicturePath({
            catalogid: catalogid!,
            picid: picid!,
            picname: fileName,
          }).then((response) => {
            if (response.code === '200') {
              refetch && refetch();
            }
          });
        }
        if (namePath) {
          setValueByNamePath(form, namePath, fileName);
          updateAssetCatalogOptionPicturePath({
            catalogid: catalogid!,
            optid: opid!,
            picid: picid!,
            picname: fileName,
          }).then((response) => {
            if (response.code === '200') {
              refetch && refetch();
            }
          });
        }
      } else {
        name && form.setFieldsValue({ [name]: fileName });
        namePath && setValueByNamePath(form, namePath, fileName);
      }
    } else {
      if (!simpleUpload || isNil(simpleUpload)) {
        if (name) {
          form.setFieldsValue({ [name]: file });
          updateAssetCatalogPicturePath({
            catalogid: catalogid!,
            picid: picid!,
            picname: file as any,
          }).then((response) => {
            if (response.code === '200') {
              refetch && refetch();
            }
          });
        }
        if (namePath) {
          setValueByNamePath(form, namePath, file);

          updateAssetCatalogOptionPicturePath({
            catalogid: catalogid!,
            optid: opid!,
            picid: picid!,
            picname: file as any,
          }).then((response) => {
            if (response.code === '200') {
              refetch && refetch();
            }
          });
        }
      } else {
        name && form.setFieldsValue({ [name]: file });
        namePath && setValueByNamePath(form, namePath, file);
      }
    }
    setFileList([]);
  };

  return (
    <Card
      style={{
        width: '100%',
        border: 'none',
        borderRadius: '15px',
        boxShadow: 'none',
        minHeight: namePath ? '200px' : '400px',
        maxHeight: '300px',
        maxWidth: '400px',
        WebkitBoxShadow:
          'rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
      cover={
        name ? (
          <Form.Item shouldUpdate={shouldUpdateCompare(name)}>
            {({ getFieldValue }) =>
              !isNil(getFieldValue([name])) &&
              getFieldValue([name]) !== '' &&
              getFieldValue([name]) !== 'null' ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    maxHeight: '300px',
                    alignItems: 'center',
                    marginTop: '5px',
                    borderTopRightRadius: '15px',
                    borderTopLeftRadius: '15px',
                  }}
                >
                  <Image
                    style={{
                      maxWidth: '400px',
                      maxHeight: '300px',
                      borderTopRightRadius: '15px',
                      borderTopLeftRadius: '15px',
                    }}
                    src={UPLOAD_IMG_URL + getFieldValue([name])}
                  />
                </div>
              ) : (
                <Empty
                  image={Empty.PRESENTED_IMAGE_DEFAULT}
                  imageStyle={{
                    maxWidth: '400px',
                    maxHeight: '300px',
                    margin: '50px',
                  }}
                />
              )
            }
          </Form.Item>
        ) : (
          namePath && (
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return !isNil(getFieldValue(namePath)) &&
                  getFieldValue(namePath) !== '' &&
                  getFieldValue(namePath) !== 'null' ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignContent: 'center',
                      maxHeight: '100px',
                      marginTop: '5px',
                      alignItems: 'center',
                    }}
                  >
                    <Image
                      style={{ maxWidth: '150px', maxHeight: '100px' }}
                      src={UPLOAD_IMG_URL + getFieldValue(namePath)}
                    />
                  </div>
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_DEFAULT}
                    imageStyle={{
                      maxWidth: '150px',
                      maxHeight: '70px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    style={{ maxWidth: '150px', maxHeight: '100px' }}
                  />
                );
              }}
            </Form.Item>
          )
        )
      }
    >
      <Row gutter={36} justify="center">
        <Col>
          <Upload
            name="avatar"
            // action={UPLOAD_IMG_URL}
            customRequest={(data: any) => {
              UploadDocumentFile(data.file, objectreference);
            }}
            onChange={(info) => {
              let infoFileList = [...info.fileList];
              if (info.file) {
                infoFileList = infoFileList.slice(-1);
                const fileName = infoFileList[0]?.name;
                if (fileName) {
                  infoFileList[0].url = UPLOAD_IMG_URL + fileName;
                }
                setFileList(infoFileList);
                handleUploadOrRemove(fileName, 'UPLOAD');
              }
            }}
            onRemove={(param) => {
              if (name) {
                form.setFieldsValue({ [name]: null });
              }
              if (namePath) {
                setValueByNamePath(form, namePath, null);
              }
            }}
            fileList={fileList}
          >
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        </Col>
        <Col>
          <Button
            danger
            onClick={() => {
              handleUploadOrRemove(null, 'REMOVE');
            }}
          >
            Delete
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default AssetUpload;
